import { COLORS } from '@btime/constants'
import React from 'react'

import { Absolute } from '../../../components/helpers/Position'
import { useQueryParams } from '../../../utils/contexts/UrlProvider'
import { useTypeTranslation } from '../_context/PlaceTypeContext'
import Message from '../../../components/messenger/Message'

const SendFormGuideBar = () => {
  const { t } = useTypeTranslation(['sendForm'])
  const { formId, formName } = useQueryParams()
  if (!formId) return false

  return (
    <Absolute top={0} left={0} right={0} zIndex={100} useSpace>
      <Message title={t('guide.title') + formName} color={COLORS.dark2} bgColor={COLORS.light2} noRadius />
    </Absolute>
  )
}

export default SendFormGuideBar
